import { colorAttentionBlue50, colorAttentionRed10, colorAttentionRed50, colorAttentionRed60, colorFunctionalGray10, colorFunctionalGray20, colorFunctionalGray30, colorFunctionalGray50, colorFunctionalGray70, colorFunctionalWhite, colorMiscGreen20, colorMiscGreen30, colorMiscGreen40, colorMiscBlue20, colorMiscBlue30, colorMiscBlue40, colorMiscBlue70, colorMiscGray90, colorMiscRed20, colorAttentionGreen50, } from "@rhumbix/rmbx_design_system_design_tokens";
// Button states for a selector button (e.g. a button in a toolbar/action-bar)
export const standardButtonStyles = {
    // There has been no action taken using the selector, but it is available.
    default: {
        bgColor: colorFunctionalGray10,
        borderColor: colorFunctionalGray50,
        fontWeight: 400,
        iconColor: colorFunctionalGray70,
        textColor: colorFunctionalGray70,
    },
    // The user has applied an element, using an input method such as a mouse, keyboard, or voice.
    active: {
        bgColor: colorFunctionalGray10,
        borderColor: colorFunctionalGray50,
        fontWeight: 400,
        iconColor: colorFunctionalGray70,
        textColor: colorFunctionalGray70,
    },
    // The user has placed a cursor above an interactive element.
    hovered: {
        bgColor: colorFunctionalGray10,
        borderColor: colorFunctionalGray30,
        fontWeight: 500,
        iconColor: colorFunctionalGray50,
        textColor: colorFunctionalGray50,
    },
    // (Micro-interaction) The user has tapped an element.
    pressed: {
        bgColor: colorFunctionalGray20,
        borderColor: colorFunctionalGray30,
        fontWeight: 500,
        iconColor: colorFunctionalGray50,
        textColor: colorFunctionalGray50,
    },
};
// Button states for a destructive button, see: standardButtonStyles
export const standardDestructiveButtonStyles = {
    default: {
        ...standardButtonStyles.default,
        borderColor: colorAttentionRed50,
        iconColor: colorAttentionRed60,
        textColor: colorAttentionRed60,
    },
    hovered: {
        ...standardButtonStyles.hovered,
        bgColor: colorAttentionRed10,
        borderColor: colorAttentionRed50,
        iconColor: colorAttentionRed60,
        textColor: colorAttentionRed60,
    },
    pressed: {
        ...standardButtonStyles.pressed,
        bgColor: colorMiscRed20,
        borderColor: colorAttentionRed50,
        iconColor: colorAttentionRed60,
        textColor: colorAttentionRed60,
    },
};
// Button states for a modal primary button, see: standardButtonStyles
export const standardModalPrimaryButtonStyles = {
    default: {
        ...standardButtonStyles.default,
        bgColor: colorAttentionGreen50,
        borderColor: colorAttentionGreen50,
        iconColor: colorFunctionalWhite,
        textColor: colorFunctionalWhite,
    },
    hovered: {
        ...standardButtonStyles.hovered,
        bgColor: colorMiscGreen20,
        borderColor: colorMiscGreen30,
        iconColor: colorFunctionalWhite,
        textColor: colorFunctionalWhite,
    },
    pressed: {
        ...standardButtonStyles.pressed,
        bgColor: colorMiscGreen30,
        borderColor: colorMiscGreen40,
        iconColor: colorFunctionalWhite,
        textColor: colorFunctionalWhite,
    },
};
// Button states for a right rail primary button, see: standardButtonStyles
export const standardRightRailPrimaryButtonStyles = {
    default: {
        ...standardButtonStyles.default,
        bgColor: colorAttentionBlue50,
        borderColor: colorMiscBlue70,
        iconColor: colorFunctionalWhite,
        textColor: colorFunctionalWhite,
    },
    hovered: {
        ...standardButtonStyles.hovered,
        bgColor: colorMiscBlue30,
        borderColor: colorMiscBlue40,
        iconColor: colorFunctionalWhite,
        textColor: colorFunctionalWhite,
    },
    pressed: {
        ...standardButtonStyles.pressed,
        bgColor: colorMiscBlue40,
        borderColor: colorAttentionBlue50,
        iconColor: colorFunctionalWhite,
        textColor: colorFunctionalWhite,
    },
};
// Button states for a disabled button, see: standardButtonStyles
export const standardDisabledButtonStyles = {
    default: {
        ...standardButtonStyles.default,
        iconColor: colorFunctionalGray50,
        textColor: colorFunctionalGray50,
    },
    hovered: {
        ...standardButtonStyles.default,
        bgColor: colorFunctionalGray10,
        fontWeight: 400,
        iconColor: colorFunctionalGray50,
        textColor: colorFunctionalGray50,
    },
};
// Button states for a selector button (e.g. a button in a toolbar/action-bar)
export const selectionButtonStyles = {
    // There has been no action taken using the selector, but it is available.
    default: {
        ...standardButtonStyles.default,
        bgColor: "transparent",
        textColor: colorMiscGray90,
    },
    // The user has applied an element, using an input method such as a mouse, keyboard, or voice.
    active: {
        ...standardButtonStyles.active,
        bgColor: colorFunctionalGray10,
        textColor: colorMiscGray90,
    },
    // The user has placed a cursor above an interactive element.
    hovered: {
        ...standardButtonStyles.hovered,
        bgColor: colorMiscBlue20,
        iconColor: colorAttentionBlue50,
        textColor: colorMiscBlue70,
    },
    // (Micro-interaction) The user has tapped an element.
    pressed: {
        ...standardButtonStyles.pressed,
        bgColor: colorMiscBlue30,
        iconColor: colorAttentionBlue50,
        textColor: colorMiscBlue70,
    },
};
// Button states for a destructive toolbar button, see: selectionButtonStyles
export const destructiveButtonStyles = {
    default: {
        ...selectionButtonStyles.default,
        iconColor: colorAttentionRed60,
        textColor: colorAttentionRed60,
    },
    hovered: {
        ...selectionButtonStyles.hovered,
        bgColor: colorAttentionRed10,
        iconColor: colorAttentionRed60,
        textColor: colorAttentionRed60,
    },
    pressed: {
        ...selectionButtonStyles.pressed,
        bgColor: colorMiscRed20,
        iconColor: colorAttentionRed60,
        textColor: colorAttentionRed60,
    },
};
// Button states for a disabled toolbar button, see: selectionButtonStyles
export const disabledButtonStyles = {
    default: {
        ...selectionButtonStyles.default,
        iconColor: colorFunctionalGray50,
        textColor: colorFunctionalGray50,
    },
    hovered: {
        ...selectionButtonStyles.default,
        bgColor: colorFunctionalGray10,
        fontWeight: 400,
        iconColor: colorFunctionalGray50,
        textColor: colorFunctionalGray50,
    },
};
